import uuid from 'uuid';

import environmentNames from '../environmentNames';
import apiService from './ApiService';

let trackJs;
if (process.env.NODE_ENV === environmentNames.PRODUCTION) {
    trackJs = require('trackjs');
}

function formatResponseError(error) {
    if (error.response) {
        return { status: error.response.status, url: error.response.url };
    }
    return error;
}

function discardError(error) {
    const errorIsDefined = error && error !== '';
    if (!errorIsDefined) {
        return true;
    }

    const errorIsResponseError = apiService.isResponseError(error);
    if (errorIsResponseError) {
        if (error.errorType === apiService.responseCategories.OFFLINE
            || error.errorType === apiService.responseCategories.TIMEOUT
            || error.errorType === apiService.responseCategories.FORBIDDEN
            || error.errorType === apiService.responseCategories.NOT_LOGGED_IN) {
            return true;
        }
        if (error.response && error.response.url.includes('NotifyClientEvent')) {
            return true;
        }
    }

    return false;
}

export function logToExternalErrorTracking(error, hash) {
    let formattedError = error;

    if (discardError(error)) {
        return;
    }

    // For response errors we build a simplified object since TrackJS doesn't keep all values of the error objects
    if (apiService.isResponseError(error)) {
        formattedError = `${JSON.stringify(formatResponseError(error))} - ${hash}`;
    }

    if (trackJs) {
        trackJs.track(formattedError);
    }
}

function getErrorHash() {
    const hash = uuid.v4();
    return typeof hash === 'string' ? hash.substring(0, 8) : undefined;
}

function logResponseError(error) {
    const hash = getErrorHash();

    logToExternalErrorTracking(error, hash);
}

/**
 * Directly reporting errors to trackJs and Live Monitor as promises are swallowing the errors
 * http://jamesknelson.com/are-es6-promises-swallowing-your-errors/
 * @param error
 */
export function reportError(error) {
    const isUnitTestEnv = process.env.NODE_ENV === environmentNames.UNIT_TESTING;
    if (isUnitTestEnv) {
        return;
    }

    if (discardError(error)) {
        return;
    }

    if (apiService.isResponseError(error)) {
        logResponseError(error);
    } else {
        // For non-response errors we still need to make sure they get logged to TrackJS
        logToExternalErrorTracking(error);
    }
}

export function configureTrackJs() {
    if (trackJs) {
        trackJs.configure({
            onError(payload) {
                // TrackJS fails with HTTP 413 if the report is too big
                payload.console = payload.console.slice(Math.max(payload.console.length - 10, 0));

                return true;
            },
        });
    }
}

export function configureErrorLogging() {
    window.addEventListener('unhandledrejection', (event) => {
        const reason = event.detail ? event.detail.reason : event.reason;
        reportError(reason);
    });
}



/** WEBPACK FOOTER **
 ** ./src/services/ErrorReporting.js
 **/